import ROUTES from '@lib/constants/routes';
import { ScrollSmoother } from '@lib/tools/gsap-init';

const NEWS_SCROLL_KEY = 'news_scroll_pos';

const getNewsScrollStorage = () => {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage;
};

const readStoredNewsScroll = () => {
  const raw = getNewsScrollStorage()?.getItem(NEWS_SCROLL_KEY);
  if (raw == null) return null;

  const position = Number(raw);
  return Number.isFinite(position) ? position : null;
};

const writeStoredNewsScroll = position => {
  const storage = getNewsScrollStorage();
  if (!storage) return;

  try {
    storage.setItem(NEWS_SCROLL_KEY, String(position));
  } catch {
    return;
  }
};

export const getScrollSmoother = () => ScrollSmoother.get?.() ?? null;

export const getScrollPosition = () => {
  const smoother = getScrollSmoother();
  if (smoother) return smoother.scrollTop();
  return window.scrollY || document.documentElement.scrollTop;
};

export const setScrollPosition = position => {
  const y = Number(position) || 0;
  const smoother = getScrollSmoother();

  if (smoother) {
    smoother.scrollTo(y, { duration: 0 });
    return;
  }

  window.scrollTo(0, y);
};

export const saveNewsScrollPosition = () => {
  const position = getScrollPosition();
  writeStoredNewsScroll(position);
  return position;
};

export const readNewsScrollPosition = () => {
  const stored = readStoredNewsScroll();
  return stored ?? getScrollPosition();
};

export const isNewsRoute = pathname => {
  const normalized = pathname?.replace(/\/+$/, '') || '/';
  const newsRoot = ROUTES.news.root.replace(/\/+$/, '');
  return normalized === newsRoot || normalized.startsWith(`${newsRoot}/`);
};

export const preserveNewsScroll = () => {
  const saved = readNewsScrollPosition();
  const smoother = getScrollSmoother();
  const isLocked = Object.hasOwn(document.body.dataset, 'bodyScrollFix');

  if (smoother) {
    smoother.scrollTo(saved, { duration: 0 });

    if (isLocked) {
      smoother.paused(true);
      const wrapper = document.getElementById('smooth-wrapper');
      if (wrapper) wrapper.style.overflow = 'hidden';
    }

    return saved;
  }

  if (isLocked) {
    document.body.dataset.bodyScrollFix = String(saved);
    document.body.style.top = `-${saved}px`;
    return saved;
  }

  setScrollPosition(saved);
  return saved;
};
